<div class="dropdown">
  <label for="actions-dropdown"
    >{{ 'COMMON.LABEL.ACTIONS' | translate }}:
  </label>
  <div class="input">
    <p-select
      inputId="actions-dropdown"
      appendTo="body"
      panelStyleClass="actions-dropdown-panel"
      [options]="availableActions()"
      optionLabel="label"
      [(ngModel)]="currentAction"
      placeholder="{{ 'COMMON.LABEL.SELECT_ACTION' | translate }}"
      (onChange)="this.actionSelected.emit($event.value.value)"
      [disabled]="isDisabled"
      scrollHeight="calc(100vh - 35vh)"
    />
  </div>
</div>
